<template>
  <t-container>
    <div
      v-if="left === true"
      class="grid grid-cols-1 px-4 lg:grid-cols-2 mt-6 lg:grid-rows-1 lg:gap-5 items-end lg:items-center lg:py-7"
    >
      <t-gradient-image
        :left="true"
        :img-src="imgSource + sizing"
      />
      <t-text-section class="py-6">
        <h2>
          <slot name="heading" />
        </h2>
        <div class="py-2">
          <slot name="text" />
        </div>
        <slot />
      </t-text-section>
    </div>
    <div
      v-if="left === false"
      class="grid justify-items-end grid-cols-1 mt-6 px-4 lg:grid-cols-2 lg:grid-rows-1 gap-5 items-end lg:items-center lg:py-7"
    >
      <t-text-section class="pb-6 lg:py-6 order-last lg:order-none">
        <h2>
          <slot name="heading" />
        </h2>
        <div class="py-2">
          <slot name="text" />
        </div>
        <slot />
      </t-text-section>
      <t-gradient-image
        :left="false"
        class="order-first lg:order-none"
        :img-src="imgSource + sizing"
      />
    </div>
  </t-container>
</template>

<script>
export default {
  name: 'ImageAndText',
  props: {
    left: {
      type: Boolean,
      default: true,
    },
    imgSource: {
      type: String,
      default: '//summitproedu.imgix.net/redesign-assets/pages/about/About_EveryFormat.jpg',
    },
  },
  data() {
    return {
      sizing: '?fit=crop&w=512&h=341.484',
    };
  },
};
</script>
